import { render, staticRenderFns } from "./ProductPPimgs.vue?vue&type=template&id=3c7aba9a&"
import script from "./ProductPPimgs.vue?vue&type=script&lang=js&"
export * from "./ProductPPimgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports